import i from './main-menu.container';

export default i;
